module.exports = __webpack_public_path__ + "assets/img/Twitter-white.92be22c5.svg";